const FEATURE_HELP_URLS = {
  agent_bots: 'https://actichat.app/hc/agent-bots',
  agents: 'https://actichat.app/hc/agents',
  audit_logs: 'https://actichat.app/hc/audit-logs',
  campaigns: 'https://actichat.app/hc/campaigns',
  canned_responses: 'https://actichat.app/hc/canned',
  channel_email: 'https://actichat.app/hc/email',
  channel_facebook: 'https://actichat.app/hc/fb',
  custom_attributes: 'https://actichat.app/hc/custom-attributes',
  dashboard_apps: 'https://actichat.app/hc/dashboard-apps',
  help_center: 'https://actichat.app/hc/help-center',
  inboxes: 'https://actichat.app/hc/inboxes',
  integrations: 'https://actichat.app/hc/integrations',
  labels: 'https://actichat.app/hc/labels',
  macros: 'https://actichat.app/hc/macros',
  reports: 'https://actichat.app/hc/reports',
  sla: 'https://actichat.app/hc/sla',
  team_management: 'https://actichat.app/hc/teams',
  webhook: 'https://actichat.app/hc/webhooks',
  billing: 'https://actichat.app/pricing',
  saml: 'https://actichat.app/hc/saml',
  captain_billing: 'https://actichat.app/hc/captain_billing',
};

export function getHelpUrlForFeature(featureName) {
  return FEATURE_HELP_URLS[featureName];
}
